/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/order-rx-list';
 */
export const layoutConfig = {
    dimensions: {
        maxHeight: 260,
        padding: 0,
    },
    columnWidth: {
        rxNumber: 60,
        drugName: 80,
        daysSupply: 50,
        quantity: 50,
        amountPaid: 60,
        queue: 100,
        status: 100,

        // special columns
        _selectionActions: 16, // checkbox selection
        _groupActions: 100, // group actions column
    },
    filterFlyoutWidths: {},
    valueColors: {},
    actionIcons: {
        notes: 'callNotes',
        markResolved: 'checkedCircle'
    },
    columnIcons: {
        drugName: {
            name: 'info',
            path: 'values.drugNameInfo'
        }
    }
};

